import type {TypedSchema} from 'schemaDefinition/types';
import type {ExternalSuggestions} from 'services/metadata/types';

export const externalSuggestionsSchema: TypedSchema<ExternalSuggestions> = {
  name: 'externalSuggestions',
  parts: [
    {
      name: 'intellectualLevel',
      type: 'text',
      cardinality: 'multiple',
    },
    {
      name: 'seriesTitles',
      key: 'seriesTitles.suggestion',
      type: 'text',
      cardinality: 'multiple',
    },
    {
      name: 'seriesNumbers',
      key: 'seriesNumbers.suggestion',
      type: 'text',
      cardinality: 'multiple',
    },
  ],
};
